import styled from 'styled-components';
const LoaderButtonContainer = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: end;
  justify-content: center;
`;
export default LoaderButtonContainer;
